<template>
<div>
  <block-form-component @add="addBlock"></block-form-component>
  <table class="table">
    <thead>
      <tr>
        <th scope="col">Num</th>
        <th scope="col">From</th>
        <th scope="col">To</th>
        <th scope="col"></th>
      </tr>
    </thead>
    <tbody v-model="blocks" tag="tbody">
      <block-component v-for="(block, index) in blocks" :block="block" :key="index" :idx="index" @delete="deleteBlock"></block-component>
    </tbody>
  </table>
  <input type="hidden" name="blocks" v-model="json_blocks" />
</div>
</template>

<script>

export default {
  name: "BlockEdit",
  data() {
    return {
      show: false,
      blocks: [],
      json_blocks: ''
    }
  },
  watch: {
    blocks: {
      handler: function(val, oldVal) {
        console.log('watch blocks');
        this.json_blocks = JSON.stringify(this.blocks);
      },
      deep: true
    }
  },
  methods: {
    deleteBlock (idx) {
      console.log('deleteBlock');
      this.blocks.splice(idx, 1);
    },
    addBlock (block) {
      block.number  = this.blocks.length + 1;
      const clone = Object.assign({},block);
      this.blocks.push(clone);
    }
  },
}
</script>
